import { PermissionKey, type PermissionKeyEnum } from "@fitness-app/data-models";

import { type DashboardPermissionArea } from "~/modules/Dashboard/dashboardPermissionRequirements";

export interface RoleEditorArea {
  /** Klucz requirementu z dashboardPermissionRequirements — z niego liczy się ✓ w macierzy. */
  area: DashboardPermissionArea;
  label: string;
  keys: readonly PermissionKeyEnum[];
}

// Poziom 1 edytora ról: obszary = podstrony panelu (to samo mapowanie, którym
// sidebar bramkuje pozycje). Poziom 2 (po rozwinięciu): klucze obszaru.
export const roleEditorAreas: readonly RoleEditorArea[] = [
  {
    area: "traineeList",
    label: "Lista trenujących",
    keys: [PermissionKey.CLIENTS_READ, PermissionKey.CLIENTS_WRITE],
  },
  {
    area: "chat",
    label: "Czat",
    keys: [PermissionKey.CHAT_READ, PermissionKey.CHAT_WRITE],
  },
  {
    area: "chatAlerts",
    label: "Zastrzeżenia klientów",
    keys: [PermissionKey.CHAT_ALERTS_READ],
  },
  {
    area: "sales",
    label: "Sales CRM",
    keys: [
      PermissionKey.SALES_READ,
      PermissionKey.SALES_MANAGE,
      PermissionKey.SALES_SETTLEMENTS_READ,
      PermissionKey.SALES_CHECKOUT_MANAGE,
      PermissionKey.SALES_ANALYTICS_READ,
    ],
  },
  {
    area: "products",
    label: "Produkty",
    keys: [
      PermissionKey.PRODUCTS_READ,
      PermissionKey.PRODUCTS_RESOURCES_READ,
      PermissionKey.PRODUCTS_RESOURCES_WRITE,
      PermissionKey.PRODUCTS_MANAGE,
    ],
  },
  {
    area: "programs",
    label: "Plany treningowe",
    keys: [PermissionKey.PROGRAMS_MANAGE],
  },
  {
    area: "nutrition",
    label: "Plany żywieniowe",
    keys: [
      PermissionKey.NUTRITION_MANAGE,
      PermissionKey.NUTRITION_INGREDIENTS_APPROVE,
      PermissionKey.NUTRITION_INGREDIENTS_MANAGE,
    ],
  },
  {
    area: "support",
    label: "Zgłoszenia",
    keys: [PermissionKey.SUPPORT_READ, PermissionKey.SUPPORT_MANAGE, PermissionKey.SUPPORT_RESOURCES_MANAGE],
  },
  {
    area: "engagement",
    label: "Zaangażowanie",
    keys: [PermissionKey.ENGAGEMENT_MANAGE, PermissionKey.ENGAGEMENT_BADGES_MANAGE],
  },
  {
    area: "surveys",
    label: "Ankiety",
    keys: [PermissionKey.SURVEYS_MANAGE],
  },
  {
    area: "campaigns",
    label: "Kampanie",
    keys: [PermissionKey.CAMPAIGNS_MANAGE],
  },
  {
    area: "landings",
    label: "Landingi",
    keys: [PermissionKey.LANDINGS_MANAGE],
  },
  {
    area: "marketing",
    label: "Marketing",
    keys: [PermissionKey.MARKETING_READ],
  },
  {
    area: "ai",
    label: "AI / Agenci",
    keys: [PermissionKey.AGENTS_USE],
  },
  {
    area: "automation",
    label: "Automatyzacje",
    keys: [PermissionKey.AUTOMATION_MANAGE],
  },
  {
    area: "appConfig",
    label: "Konfiguracja aplikacji",
    keys: [PermissionKey.APP_CONFIG_MANAGE],
  },
  {
    area: "helpCenter",
    label: "Centrum pomocy",
    keys: [PermissionKey.HELP_CENTER_MANAGE, PermissionKey.HELP_CENTER_PUBLISH],
  },
  {
    area: "teamArea",
    label: "Zespół",
    keys: [
      PermissionKey.TEAM_READ,
      PermissionKey.TEAM_MANAGE,
      PermissionKey.TEAM_PERMISSIONS_MANAGE,
      PermissionKey.TEAM_STATS_READ,
      PermissionKey.TEAM_CHAT_METRICS_READ,
    ],
  },
];
